<template>
  <div
    v-if="open"
    class="modal-backdrop open"
    role="dialog"
    aria-modal="true"
    aria-labelledby="purchaseTitle"
    @click.self="$emit('close')"
  >
    <div class="modal compact">
      <div class="row">
        <h2 id="purchaseTitle">{{ purchaseTitle }}</h2>
        <button type="button" class="close" aria-label="关闭" @click="$emit('close')">×</button>
      </div>
      <p class="subtext" v-html="purchaseSub"></p>
      <div class="form-group" style="margin-top: 10px">
        <label>{{ t("pay_coin") }}</label>
        <div class="coin-tabs">
          <div class="coin-opt active" role="status">
            <span class="co">{{ coin }}</span>
            <span class="cd">{{ coinSubtitle }}</span>
          </div>
        </div>
        <p class="subtext">{{ t("pay_coin_note") }}</p>
      </div>
      <div id="priceInfo">
        <div v-for="(line, i) in priceInfoLines" :key="i" class="data-line">
          <span>{{ line.label }}</span>
          <strong>{{ line.value }}</strong>
        </div>
      </div>
      <div class="form-group">
        <label for="buyQuantity">{{ t("buy_qty") }}</label>
        <div class="quantity">
          <button type="button" aria-label="减少数量" @click="changeQty(-1)">−</button>
          <input
            id="buyQuantity"
            v-model.number="quantity"
            class="input"
            type="number"
            :min="1"
            :max="maxQty"
          />
          <button type="button" aria-label="增加数量" @click="changeQty(1)">＋</button>
        </div>
      </div>
      <div class="data-line">
        <span>{{ t("pay") }}</span><strong>{{ payLine }}</strong>
      </div>
      <div class="data-line">
        <span>{{ t("upline") }}</span><strong>{{ uplineLine }}</strong>
      </div>
      <div class="data-line">
        <span>{{ t("issuer_pay") }}</span><strong>{{ payLine }}</strong>
      </div>
      <label class="check">
        <input v-model="riskChecked" type="checkbox" />
        <span>{{ t("risk_check") }}</span>
      </label>
      <button type="button" class="btn gold full" @click="confirm">
        {{ t("confirm_buy") }}
      </button>
      <p class="subtext" style="text-align: center; margin: 8px 0 0">
        {{ t("purchase_note") }}
      </p>
    </div>
  </div>
</template>

<script>
import { COIN_META, batchTotal, fmtCoin, pricingTag, projectPricing, unitPrice } from "@/film/pricing";
import { shortenAddress } from "@/film/format";
import { resolveParentFromUrl } from "@/film/referral";

export default {
  name: "PurchaseModal",
  props: {
    open: Boolean,
    t: { type: Function, required: true },
    fmt: { type: Function, required: true },
    project: { type: Object, required: true },
    sold: { type: Number, default: 0 },
    maxQty: { type: Number, default: 1 },
    chainTotalHuman: { type: String, default: "" },
    quoteLoading: { type: Boolean, default: false },
    uplineAddress: { type: String, default: "" },
    uplineLoading: { type: Boolean, default: false },
  },
  data() {
    return {
      quantity: 1,
      riskChecked: false,
    };
  },
  computed: {
    pricing() {
      return projectPricing(this.project);
    },
    coin() {
      return this.project.coin;
    },
    coinSubtitle() {
      return (COIN_META[this.coin] || COIN_META.AAPLB).subtitle;
    },
    purchaseTitle() {
      return `${this.project.name} NFT`;
    },
    purchaseSub() {
      return this.t("purchase_sub").replace(
        "1,000",
        this.project.supply.toLocaleString("en-US")
      );
    },
    priceInfoLines() {
      const coin = this.coin;
      const tag = pricingTag(this.pricing, this.t);
      if (this.project.mode === "fixed") {
        return [
          {
            label: `${coin} · ${tag}`,
            value: `${fmtCoin(this.project.fixed, coin)} ${coin} / ${this.t("stat2u")}`,
          },
        ];
      }
      const s = this.project.step;
      const lines = [
        {
          label: `${coin} · ${tag}`,
          value: `${fmtCoin(s.start, coin)} ${coin} + ${fmtCoin(s.inc, coin)} / ${this.t("stat2u")}`,
        },
        {
          label: `${this.t("next_price")}（第 ${this.sold + 1} 张）`,
          value: `${fmtCoin(unitPrice(this.pricing, this.sold + 1), coin)} ${coin}`,
        },
      ];
      return lines;
    },
    uplineLine() {
      if (this.uplineLoading) return "…";
      const raw = this.uplineAddress || resolveParentFromUrl();
      return shortenAddress(raw);
    },
    payLine() {
      const n = Number(this.quantity);
      if (!Number.isInteger(n) || n < 1) return this.t("toast_input_pos");
      if (this.quoteLoading) return "…";
      if (this.project.cardAddress && this.chainTotalHuman) {
        return this.chainTotalHuman;
      }
      const total = batchTotal(this.pricing, n, this.sold);
      return `${fmtCoin(total, this.coin)} ${this.coin}`;
    },
  },
  watch: {
    open(val) {
      if (val) {
        this.quantity = 1;
        this.riskChecked = false;
        this.$emit("quote", this.quantity);
      }
    },
    quantity(val) {
      if (this.open && this.project.cardAddress) {
        this.$emit("quote", val);
      }
    },
  },
  methods: {
    changeQty(delta) {
      const next = Math.min(this.maxQty, Math.max(1, (Number(this.quantity) || 1) + delta));
      this.quantity = next;
    },
    confirm() {
      this.$emit("confirm", {
        quantity: Number(this.quantity),
        riskChecked: this.riskChecked,
      });
    },
  },
};
</script>
